module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"outOf":"{0} - {1} ouf of {2} records","perPage":"{0} per page"}}')
  delete Component.options._Ctor
}
